import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Review icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Review } from '@sravni/design-system-icons'
 *
 * <Review />
 * ```
 */
var Review = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Review", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.5 17.927V15h4.167c.46 0 .833-.373.833-.833V3.333a.834.834 0 0 0-.833-.833H3.333a.834.834 0 0 0-.833.833v10.834c0 .46.373.833.833.833h5l4.167 2.927v0ZM12.5 10.833H5.833M5.833 6.667h8.334", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Review };
//# sourceMappingURL=Review.js.map
